import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, PlayCircle, Award } from "lucide-react";
import { api } from "@/lib/api";

export default function MyCourses() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/my/courses")
      .then((r) => setItems(r.data))
      .catch(() => setErr("Eğitimler yüklenirken bir sorun oluştu."));
  }, []);

  return (
    <div className="container-x py-16 md:py-24 min-h-[60vh]">
      <span className="section-eyebrow">Öğrenci Alanı</span>
      <h1 className="font-display text-4xl md:text-5xl mt-3 mb-10">Eğitimlerim</h1>

      {err && <div className="bg-red-950/40 border border-red-800 text-red-200 p-4 text-sm mb-8">{err}</div>}

      {items === null && !err && (
        <div className="text-white/50 text-sm">Yükleniyor...</div>
      )}

      {items && items.length === 0 && (
        <div className="bg-surface border border-white/10 p-10 text-center">
          <GraduationCap className="w-10 h-10 text-gold/60 mx-auto mb-4" />
          <p className="text-white/70 mb-6">Henüz erişiminiz olan bir eğitim bulunmuyor.</p>
          <Link to="/egitimler" className="btn-primary text-sm inline-flex">Eğitimleri İncele</Link>
        </div>
      )}

      {items && items.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => (
            <Link
              key={c.id}
              to={`/egitimlerim/${c.id}`}
              data-testid={`my-course-card-${c.slug}`}
              className="group bg-surface border border-white/10 hover:border-gold-30 transition-colors overflow-hidden flex flex-col"
            >
              <div className="aspect-video overflow-hidden relative">
                <img src={c.image_url} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                {c.progress_percent === 100 && (
                  <div className="absolute top-3 right-3 bg-gold text-black text-[10px] uppercase tracking-widest font-bold px-2 py-1 flex items-center gap-1">
                    <Award className="w-3 h-3" /> Tamamlandı
                  </div>
                )}
              </div>
              <div className="p-5 flex flex-col gap-3 flex-1">
                <div className="text-xs uppercase tracking-widest text-gold/70">{c.category}</div>
                <div className="font-display text-lg leading-snug">{c.title}</div>
                <div className="mt-auto">
                  <div className="flex items-center justify-between text-xs text-white/50 mb-1.5">
                    <span>{c.completed_count}/{c.total_lessons} ders</span>
                    <span>%{c.progress_percent}</span>
                  </div>
                  <div className="h-1.5 bg-white/10 w-full">
                    <div className="h-1.5 bg-gold" style={{ width: `${c.progress_percent}%` }} />
                  </div>
                </div>
                <div className="flex items-center gap-2 text-sm text-gold group-hover:text-gold-light mt-2">
                  <PlayCircle className="w-4 h-4" /> {c.progress_percent > 0 ? "Devam Et" : "Başla"}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
